import React from 'react'

const SmartText = ({ text, length = 200 }) => {
    const [showLess, setShowLess] = React.useState(true);
  
    if (text.length < length) {
      return <div className='font-nunito card-desc' dangerouslySetInnerHTML={{__html:text}} style={{overflowWrap:'break-word'}}></div>;
    }
  
    return (
      <div>
        <div dangerouslySetInnerHTML={{__html:showLess ? `${text.slice(0, length)}...` : text}} style={{overflowWrap:'break-word'}} className='font-nunito card-desc'>
        
        </div>
        <a
          style={{ color: "blue", cursor: "pointer",fontSize:13 }}
          onClick={() => setShowLess(!showLess)}
        >
          &nbsp;View {showLess ? "More" : "Less"}
        </a>
      </div>
    );
  };
export default SmartText